export default function FormInput({ label, value, onChange, placeholder = "" }) {
    return (
        <div className="wg-form-group">
            <label className="wg-label">{label}</label>
            <input
                className="wg-input"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
    );
}